module.exports = __webpack_public_path__ + "img/quit_icon.5dbe5422.svg";